import { FloatingPlayer } from './FloatingPlayer'

// No need for Redux anymore since we're using PlayerContext
export default FloatingPlayer;